import { Injectable } from "@angular/core";
import { UserService } from "../user/user.service";
import { LocalStorage } from "app/model/constant";
import * as moment from 'vendors/moment-locale-th';

const CURRENCY = 'THB'
@Injectable()
export class GoogleTagManagerService {
  constructor(
    private userService: UserService
  ) { }

  public emitPageView(title: String) {
    try {
      const userInfo = this.userService.getUser(false)
      const userId = userInfo ? userInfo.userId : '';
      const companyId = userInfo ? userInfo.companyId : ''
      if (typeof window !== 'undefined') {
        (<any>window).dataLayer.push({
          pageLocation: null,
          userId: null,
          companyId: null,
          pageTitle: null
        });
        (<any>window).dataLayer.push({
          event: "page_view",
          pageLocation: window.location.href,
          userId: userId,
          companyId: companyId,
          pageTitle: title
        });
      }

    } catch (error) {
      console.error(error)
    }
  }

  public emitEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null,
    title: string = ''
  ) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({
        eventCategory: null,
        eventLabel: null,
        eventAction: null,
        eventValue: null,
        title: null
      });
      (<any>window).dataLayer.push({
        event: "custom_event",
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventAction: eventAction,
        eventValue: eventValue,
        title: title
      });
    }
  }

  public emitViewItemList(items: any[]) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: items
        }
      });
    }
  }

  public emitViewItem(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public emitAddToCart(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public emitBeginCheckout(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public emitAddShippingInfo(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "add_shipping_info",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }

  }

  public emitAddPaymentInfo(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public emitPurchase(items: any[], price: number, bookingId: string) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "purchase",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          transaction_id: bookingId,
          items: items
        }
      });
    }
  }

  public emitViewPromotion(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "view_promotion",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public emitSelectPromotion(items: any[], price: number) {
    if (typeof window !== 'undefined') {
      (<any>window).dataLayer.push({ ecommerce: null });
      (<any>window).dataLayer.push({
        event: "select_promotion",
        ecommerce: {
          currency: CURRENCY,
          value: price,
          items: items
        }
      });
    }
  }

  public attachPromotionInformation(item: any) {
    try {
      const localStorageItem = JSON.parse(localStorage.getItem(LocalStorage.PROMOTION))
      if (item.item_id === localStorageItem['item_id'] && moment().isBefore(localStorageItem['expire'])) {
        item['creative_name'] = localStorageItem['creative_name']
        item['promotion_id'] = localStorageItem['promotion_id']
        item['promotion_name'] = localStorageItem['promotion_name']
      }
    } catch(ignore) {}
  }
}



// WEBPACK FOOTER //
// ./src/app/services/analytics/google-tag-manager.service.ts